<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  Основана в 2007 году, является комплексным поставщиком топлива
                  для торгующих компаний и конечных потребителей России.
                </p>
                <h4>Основное направление:</h4>
                <ul class="ViewDieselInfo__text-list">
                  <li>
                    <img
                      src="/icons/checked.svg"
                      alt=""
                      class="ViewDieselInfo__text-list-icon"
                    />Наша компания специализируется на поставках дизельного
                    топлива и бензина по всей территории Российской Федерации.
                    Имеется топливозаправщик 1000л. Можем предложить услугу
                    заправки вашего автопарка.
                  </li>
                </ul>
                <h4>Преимущества компании:</h4>
                <p>
                  Мы продаём только качественное топливо. Вся поставляемая
                  продукция проходит лабораторный анализ и соответствует
                  нормативным документам (ГОСТ), качество подтверждается
                  соответствующими сертификатами.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+79165995801"
                          class="ViewPromo__advantage-contact-link"
                          >+7 916 599-58-01</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:fedorovm@volgaresurs.ru"
                          class="ViewPromo__advantage-contact-link"
                          >fedorovm@volgaresurs.ru</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                    <p>
                      <strong>Серпуховская НБ</strong><br />
                      Московская область, Серпухов, 2-я улица Новоселок, 10
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика Волгаресурс',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1129,
    productId: 1884,
    name: 'ООО «Волгаресурс»',
    inn: '5043032214',
  }),
};
</script>
